import { oddsFormats } from "../../../container/SportsBookNode/utils/common/constants";

export const initialState = {
  loading: false,
  success: false,
  error: false,
  countries: [],
  liveCountries: [],
  sports: [],
  leagues: "",
  selectedSportId: "",
  selectedSportName: "",
  search: "",
  selectedSportImg: "/images/sport-book/default-sports.svg",
  selectedOddsFormat: oddsFormats[0],
  topSports: [],
  topLeaguesLoading: false,
  selectedTopSport: {},
  popularCountryLoading: false,
  popularCountryData: [],
  topCountry: [],
  countryLeague: [],
  selectedCountryId: "",
  selectedLeagueId: "",
  leaguesLoading: false,
  tennisTopleagues: [],
  topLeagueSport: ""
};
